import React, {useEffect, useState} from 'react'
import {Typography, Divider, Button, Row, Col} from 'antd'
import Amplify, { API, graphqlOperation } from 'aws-amplify'
import { getNewPapers } from '../../../graphql/queries'
import { Table, Tag, Space } from 'antd';
import Paper  from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import styled from 'styled-components'
import {DoubleRightOutlined, LeftOutlined} from '@ant-design/icons'
import {Link, useHistory} from 'react-router-dom'
import {ButtonPrimary} from '../../../components/Button'
import ScrollToTop from '../../../components/ScrollToTop'
const TitleDetail = styled.h1`
 font-size:2rem;
 font-family: "Roboto";
 color: #6C0E60;
 text-align: left;
`
const SubtitleDetail = styled.p`
 font-size:1rem;
 font-family: "Roboto";
 text-align: left;
 font-weight: 200
 font-variant: italic
`
const InfoDetailedTitle = styled.p`
 font-size:1rem;
 font-family: "Roboto";
 color: #6C0E60;
 text-align: left;
 font-weight: 700;
`
const GoLibraryDetailed = styled.button`
    background: none;
    font-family: "Roboto";
    font-size:1rem;
    font-weight:200;
    width:100%;
    text-align:left;
    border: none;
    width:96%;
    margin: 2% 10% 0% 0%;
`
const dataPaper = 
{
      id:"",
      titulo:"Cargando...",
      titulo_secundario:"",
      Journal:"",
      Paginas:"null",
      Volumen:"null",
      Numero:"null",
      PalabrasClave:"",
      Fecha:"",
      Url:"",
      Abstract:"Cargando...",
      Autores:"",
}


function camelCase(str) { 
    var regex =
     /[.,;A-Z\xC0-\xD6\xD8-\xDE]?[.,;a-z\xDF-\xF6\xF8-\xFF]+|[,;A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;
    var match = str.match(regex);
    let result = "";

    
    if(match !== null){
      for(let i = 0 , len = match.length; i < len; i++) {
        let currentStr = match[i];
        let tempStr = currentStr.toLowerCase();
        if(i != 0 || i != 1) {
          // convert first letter to upper case (the word is in lowercase) 
            tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1) + " ";
        }
        result +=tempStr;
      }
      return result.replace(/([a-z])([A-Z])/g, '$1 $2')
    }
    else{
        return null
    }
      //.replace(/([a-zA-Z])([A-Z])([a-z])/g, '$1 $2$3')
} 
function camelCaseAbstract(str) { 
    var regex = 
    /[-.,;:A-Z\xC0-\xD6\xD8-\xDE](?:[-., \x41-\x5a\xc0-\xd6\xd8-\xde\u0100\u0102\u0104\u0106\u0108\u010a\u010c\u010e\u0110\u0112\u0114\u0116\u0118\u011a\u011c\u011e\u0120\u0122\u0124\u0126\u0128\u012a\u012c\u012e\u0130\u0132\u0134\u0136\u0139\u013b\u013d\u013f\u0141\u0143\u0145\u0147\u014a\u014c\u014e\u0150\u0152\u0154\u0156\u0158\u015a\u015c\u015e\u0160\u0162\u0164\u0166\u0168\u016a\u016c\u016e\u0170\u0172\u0174\u0176\u0178\u0179\u017b\u017d\u0181\u0182\u0184\u0186\u0187\u0189-\u018b\u018e-\u0191\u0193\u0194\u0196-\u0198\u019c\u019d\u019f\u01a0\u01a2\u01a4\u01a6\u01a7\u01a9\u01ac\u01ae\u01af\u01b1-\u01b3\u01b5\u01b7\u01b8\u01bc\u01c4\u01c5\u01c7\u01c8\u01ca\u01cb\u01cd\u01cf\u01d1\u01d3\u01d5\u01d7\u01d9\u01db\u01de\u01e0\u01e2\u01e4\u01e6\u01e8\u01ea\u01ec\u01ee\u01f1\u01f2\u01f4\u01f6-\u01f8\u01fa\u01fc\u01fe\u0200\u0202\u0204\u0206\u0208\u020a\u020c\u020e\u0210\u0212\u0214\u0216\u0218\u021a\u021c\u021e\u0220\u0222\u0224\u0226\u0228\u022a\u022c\u022e\u0230\u0232\u023a\u023b\u023d\u023e\u0241\u0243-\u0246\u0248\u024a\u024c\u024e][\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]*)?(?:[a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F][\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]*)+|(?:[\x41-\x5a\xc0-\xd6\xd8-\xde\u0100\u0102\u0104\u0106\u0108\u010a\u010c\u010e\u0110\u0112\u0114\u0116\u0118\u011a\u011c\u011e\u0120\u0122\u0124\u0126\u0128\u012a\u012c\u012e\u0130\u0132\u0134\u0136\u0139\u013b\u013d\u013f\u0141\u0143\u0145\u0147\u014a\u014c\u014e\u0150\u0152\u0154\u0156\u0158\u015a\u015c\u015e\u0160\u0162\u0164\u0166\u0168\u016a\u016c\u016e\u0170\u0172\u0174\u0176\u0178\u0179\u017b\u017d\u0181\u0182\u0184\u0186\u0187\u0189-\u018b\u018e-\u0191\u0193\u0194\u0196-\u0198\u019c\u019d\u019f\u01a0\u01a2\u01a4\u01a6\u01a7\u01a9\u01ac\u01ae\u01af\u01b1-\u01b3\u01b5\u01b7\u01b8\u01bc\u01c4\u01c5\u01c7\u01c8\u01ca\u01cb\u01cd\u01cf\u01d1\u01d3\u01d5\u01d7\u01d9\u01db\u01de\u01e0\u01e2\u01e4\u01e6\u01e8\u01ea\u01ec\u01ee\u01f1\u01f2\u01f4\u01f6-\u01f8\u01fa\u01fc\u01fe\u0200\u0202\u0204\u0206\u0208\u020a\u020c\u020e\u0210\u0212\u0214\u0216\u0218\u021a\u021c\u021e\u0220\u0222\u0224\u0226\u0228\u022a\u022c\u022e\u0230\u0232\u023a\u023b\u023d\u023e\u0241\u0243-\u0246\u0248\u024a\u024c\u024e][\u0300-\u036F\u1AB0-\u1AFF\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]*)+(?![a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F])|[\d]+|[\u2700-\u27BF]|[^\x00-\x2F\x3A-\x40\x5B-\x60\x7b-\xBF\xD7\xF7\u2000-\u206F\s\uFEFF\xA0]+/g;
    var match = str.match(regex);
    let result = "";

      for(let i = 0 , len = match.length; i < len; i++) {
        let currentStr = match[i];
        let tempStr = currentStr.toLowerCase()
        let lengthcurrentstr = currentStr.length;
        let nextStr = match[i+1]


        if(tempStr.includes("- ")){
            tempStr = tempStr.replace("- ","")
        }

        tempStr = tempStr + " "

        if(nextStr !== undefined){
            if(nextStr.includes("- ")){
                tempStr = tempStr.substr(-tempStr.length,tempStr.length-1)
            }
        }
        
        if(i === 0){
            tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1) + " ";
        }

        if(tempStr.includes(".")){
            tempStr = tempStr.substr(0,3).toUpperCase()+ tempStr.substr(3);
        }
    
        result += tempStr;
      }

      let FinalResult = result.replace(/([a-z])([A-Z])/g, '$1 $2')
      return FinalResult
      //
} 

const DetailLibrary = (props)=>{
    const [paperID, setPaperID] = useState(props.match.params.bookID)
    let [info, setinfo] = useState(dataPaper)
    let PalabrasClaveGet = "Cargando..."
    let AutoresGet = "Cargando... "

    useEffect(()=>{
        var myDiv = document.getElementById('librarydetail');
        myDiv.scrollTop = 0;
    },[])

    useEffect( async ()=>{
        const DataPapers = await API.graphql(graphqlOperation(getNewPapers, {id:paperID}))
        setinfo(DataPapers.data.getNewPapers)
        return () => {
            console.log()
        }
      },[]) 

    return(
        <div id="librarydetail" className="slide-in-left" style={{padding: "3%"}}>
            <Link to="/biblioteca">
                <div style={{height:"80px"}}>
                    <GoLibraryDetailed><LeftOutlined />Volver a la  Biblioteca</GoLibraryDetailed>
                </div>
            </Link>
            <Paper id="header-for-link" style={{padding: "3%"}}  elevation={3}>
            <Row>
                <Col span={18}>
                <TitleDetail>{info.titulo_orig}</TitleDetail>
                <SubtitleDetail><i>{info.titulo_secundario_orig}</i></SubtitleDetail>
                <SubtitleDetail><i><strong style={{color:"#6C0E60"}}>Autores : </strong>{info.Autores_orig}</i></SubtitleDetail>
                <SubtitleDetail><i><strong style={{color:"#6C0E60"}}>Palabras Clave : </strong> {info.PalabrasClave_orig}</i></SubtitleDetail>
                <SubtitleDetail><strong style={{color:"#6C0E60"}}>Abstract</strong></SubtitleDetail>
                <Divider className="detailpaper-divider"/>
                <div>
                    <Row>
                        <Col span={24}><p style={{textAlign:"justify", textJustify:"inter-word", fontSize:"1.2rem"}}>{info.Abstract_orig}</p></Col>
                    </Row> 
                </div>
                <div>
                    <Row>
                        <Col span={24}>
                            <List>
                                <ListItem>
                                    <Row className="detailpaper-row-list">
                                        <Col span={24}>
                                            <div style={{display: "inline-flex", alignContent:"center", alignItems:"baseline"}}>
                                                <DoubleRightOutlined style={{margin: "0px 10px 0px 0px"}} /><InfoDetailedTitle>Volumen</InfoDetailedTitle>
                                            </div>
                                            <p>{info.Volumen}</p>
                                        </Col>
                                    </Row>
                                </ListItem>

                                <Divider className="detailpaper-divider-list"/>

                                <ListItem>
                                    <Row className="detailpaper-row-list">
                                        <Col span={24}>
                                            <div style={{display: "inline-flex", alignContent:"center", alignItems:"baseline"}}>
                                                <DoubleRightOutlined style={{margin: "0px 10px 0px 0px"}} /><InfoDetailedTitle>Numero</InfoDetailedTitle>
                                            </div>
                                            <p>{info.Numero}</p>
                                        </Col>
                                    </Row>
                                </ListItem>

                                <Divider className="detailpaper-divider-list"/>

                                <ListItem>
                                    <Row className="detailpaper-row-list">
                                        <Col span={24}>
                                            <div style={{display: "inline-flex", alignContent:"center", alignItems:"baseline"}}>
                                                <DoubleRightOutlined style={{margin: "0px 10px 0px 0px"}} /><InfoDetailedTitle>Fecha</InfoDetailedTitle>
                                            </div>
                                            <p>{info.Fecha}</p>
                                        </Col>
                                    </Row>
                                </ListItem>

                                <Divider className="detailpaper-divider-list"/>

                                <ListItem>
                                    <Row className="detailpaper-row-list">
                                        <Col span={24}>
                                            <div style={{display: "inline-flex", alignContent:"center", alignItems:"baseline"}}>
                                                <DoubleRightOutlined style={{margin: "0px 10px 0px 0px"}} /><InfoDetailedTitle>Páginas</InfoDetailedTitle>
                                            </div>
                                            <p>{info.Paginas}</p>
                                        </Col>
                                    </Row>
                                </ListItem>

                                <Divider className="detailpaper-divider-list"/>

                                <ListItem>
                                    <Row className="detailpaper-row-list">
                                        <Col span={24}>
                                            <div style={{display: "inline-flex", alignContent:"center", alignItems:"baseline"}}>
                                                <DoubleRightOutlined style={{margin: "0px 10px 0px 0px"}} /><InfoDetailedTitle>URL</InfoDetailedTitle>
                                            </div>
                                            <p><a href={info.Url_orig}>{info.Url}</a></p>
                                        </Col>
                                    </Row>
                                </ListItem>

                                <Divider className="detailpaper-divider-list"/>

                                <ListItem>
                                    <Row className="detailpaper-row-list">
                                        <Col span={24}>
                                            <div style={{display: "inline-flex", alignContent:"center", alignItems:"baseline"}}>
                                                <DoubleRightOutlined style={{margin: "0px 10px 0px 0px"}} /><InfoDetailedTitle>Licencia</InfoDetailedTitle>
                                            </div>
                                            <p className="detailpaper-datavalue">{info.Licencia === "" ? "CC" : info.Licencia }</p>
                                        </Col>
                                    </Row>
                                </ListItem>

                                <ListItem>
                                    <Row className="detailpaper-row-list">
                                        <Col span={24}>
                                        <div style={{display: "inline-flex", alignContent:"center", alignItems:"baseline"}}>
                                                <DoubleRightOutlined style={{margin: "0px 10px 0px 0px"}} /><InfoDetailedTitle>Idioma</InfoDetailedTitle>
                                            </div>
                                            <p>{info.Idioma}</p>
                                        </Col>
                                    </Row>
                                </ListItem>

                            </List>
                        </Col>
                        <Col span={6}><div></div></Col>
                    </Row> 
                </div>
                </Col>
                <Col span={6}>
                    <a href={info.Url_orig} target="_blank">
                    <ButtonPrimary color="white" background="#6C0E60">Ver link</ButtonPrimary>
                    </a>
                </Col>
            </Row>
            </Paper>
        </div>
    )
}

export default DetailLibrary